/* Baron Biotechs: luxury motion layer */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var range = function (p, a, b) { return clamp((p - a) / (b - a), 0, 1); };
  var tasks = [];
  function onFrame(fn) { tasks.push(fn); }

  /* ---------- scroll progress bar ---------- */
  var bar = document.createElement('div'); bar.className = 'lx-progress'; document.body.appendChild(bar);
  onFrame(function () {
    var h = document.documentElement.scrollHeight - innerHeight;
    bar.style.transform = 'scaleX(' + (h > 0 ? clamp(scrollY / h, 0, 1) : 0).toFixed(4) + ')';
  });

  /* ---------- reveals ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lx-in'); io.unobserve(e.target); } });
  }, { threshold: .15, rootMargin: '0px 0px -60px 0px' }) : null;
  function reveal(sel, cls) {
    $$(sel).forEach(function (el) { if (reduce || !io) return; el.classList.add(cls); io.observe(el); });
  }
  reveal('.split .ph', 'lx-clip');
  reveal('.lg-item', 'lx-clip');

  /* ---------- parallax ---------- */
  if (!reduce) {
    $$('.ib-img').forEach(function (el) { if (!el.hasAttribute('data-parallax')) el.setAttribute('data-parallax', '0.12'); });
    var px = $$('[data-parallax]');
    onFrame(function () {
      if (innerWidth < 800) return;
      px.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var k = parseFloat(el.getAttribute('data-parallax')) || .1;
        var off = (r.top + r.height / 2 - innerHeight / 2) * -k;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(' + (1 + k * .9).toFixed(3) + ')';
      });
    });
  }

  /* ---------- product card tilt ---------- */
  if (fine && !reduce) {
    $$('.pcard').forEach(function (c) {
      c.classList.add('lx-tilt');
      var g = document.createElement('span'); g.className = 'lx-glare'; c.appendChild(g);
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        c.style.transform = 'perspective(900px) rotateX(' + ((.5 - y) * 7).toFixed(2) + 'deg) rotateY(' + ((x - .5) * 9).toFixed(2) + 'deg) translateY(-4px)';
        c.style.setProperty('--gx', (x * 100).toFixed(1) + '%'); c.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });
  }

  /* ---------- box reveal ---------- */
  $$('[data-box-reveal]').forEach(function (root) {
    var box = root.querySelector('.bxr-box'), beats = $$('.bxr-beat', root), caps = $$('.cap', root);
    // flight plan for each capsule: final position (in box widths), spin, delay
    var plan = [
      [-1.4, -.5, .3, -34], [1.4, -.55, .2, 30], [-1.15, -1.2, -.2, -18], [1.15, -1.25, .25, 20], [-.62, -1.7, .4, -10],
      [.62, -1.72, .1, 12], [0, -1.95, -.2, 4], [-1.7, .25, .45, -48], [1.7, .2, -.3, 44], [0, -1.35, .65, -4]
    ];
    function set(p) {
      var st = getComputedStyle(root), W = parseFloat(st.getPropertyValue('--W')) || box.offsetWidth || 200, H = W * 1.4227;
      var lid = ease(range(p, .16, .42));
      var ry = -36 + 24 * ease(range(p, 0, .5)) - 8 * ease(range(p, .6, 1));
      root.style.setProperty('--p', p.toFixed(4));
      root.style.setProperty('--lid', lid.toFixed(4));
      root.style.setProperty('--ry', ry.toFixed(2) + 'deg');
      var t = performance.now() / 1000;
      caps.forEach(function (c, i) {
        var f = plan[i], k = ease(range(p, .34 + i * .035, .66 + i * .03));
        if (k <= 0) { c.style.opacity = 0; return; }
        var xs = Math.min(1.08, (innerWidth / 2 - 22) / (1.75 * W)), x = f[0] * W * xs * k, z = f[2] * W * k;
        var ty = f[1] * W * .7 - W * .05, y = (-H * .32) + (ty - (-H * .32)) * k - Math.sin(k * Math.PI) * W * .3;
        var bob = k >= 1 && !reduce ? Math.sin(t * 1.4 + i) * 6 : 0;
        var rot = f[3] * k + (1 - k) * 0;
        var s = .55 + .45 * k;
        c.style.opacity = clamp(k * 4, 0, 1);
        c.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + (y + bob).toFixed(1) + 'px,' + z.toFixed(1) + 'px) rotateY(' + (-ry).toFixed(1) + 'deg) rotateX(14deg) rotateZ(' + rot.toFixed(1) + 'deg) scale(' + s.toFixed(3) + ')';
      });
      var b = p < .3 ? 0 : p < .64 ? 1 : 2;
      beats.forEach(function (el, i) { el.classList.toggle('on', i === b); });
    }
    if (reduce) { set(1); return; }
    var last = -1;
    onFrame(function () {
      var r = root.getBoundingClientRect();
      if (r.bottom < -50 || r.top > innerHeight + 50) return;
      var p = clamp(-r.top / Math.max(1, r.height - innerHeight), 0, 1);
      if (p !== last || p >= .66) { set(p); last = p; }
    });
    set(0);
  });

  /* ---------- safety net: never leave reached content invisible (fast flicks can skip observers) ---------- */
  var lastSweep = 0;
  onFrame(function () {
    var now = Date.now(); if (now - lastSweep < 400) return; lastSweep = now;
    $$('.fade:not(.in), .lx-clip:not(.lx-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight - 20 && r.left < innerWidth && r.width > 0) el.classList.add(el.classList.contains('lx-clip') ? 'lx-in' : 'in');
    });
  });

  /* ---------- single rAF loop ---------- */
  function loop() { for (var i = 0; i < tasks.length; i++) tasks[i](); requestAnimationFrame(loop); }
  requestAnimationFrame(loop);
})();
